import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../../assets/styles/media';
import THEME from '../../../../assets/styles/config';

interface SlaProps {
  active?: boolean;
  cardBorder?: string;
  cardActiveBorder?: string;
  cardShadow?: string;
  home?: boolean;
}

export const ActiveArrow = styled.div<SlaProps>`
  height: 26px;
  width: 26px;
  border-radius: 26px;
  position: absolute;
  right: -13px;
  top: 50%;
  margin-top: -13px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  > svg {
    stroke: white;
  }
  ${(props): SimpleInterpolation =>
    css &&
    !props.home &&
    !props.active &&
    `
      background-color: ${props.cardBorder};
    `}

  ${(props): SimpleInterpolation =>
    css &&
    !props.home &&
    props.active &&
    `
      opacity: 1;
      background-color: ${props.cardBorder};

      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        display: none;
      }
    `}
`;

export const BtmCtn = styled.div`
  display: flex;
  justify-content: space-between;
  
  ${Media.Below.mobileLarge`
    flex-wrap: wrap;
  `}
`;

export const CardBody = styled.div<SlaProps>`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 13px 16px 13px 27px;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  transition: all 0.3s ease-in-out;

  ${(props): SimpleInterpolation =>
    css &&
    `
      box-shadow: 0px 0px 0px 0px ${props.cardActiveBorder}, 0px 0px 0px 0px ${props.cardActiveBorder}, -5px 0px 0px 0px ${props.cardBorder}, 0 3px 10px 0 ${props.cardShadow};
    `}

  ${(props): SimpleInterpolation =>
    css &&
    !props.home &&
    props.active &&
    `
      box-shadow: 1px -1px 0px 1px ${props.cardActiveBorder}, 1px 1px 0px 1px ${props.cardActiveBorder}, -3px 0px 0px 2px ${props.cardBorder}, 0 3px 20px 0 ${props.cardShadow};
      margin-left: 25px;
      margin-right: 0px;

      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        margin: 0;
      }
    `}

  ${(props): SimpleInterpolation =>
    css &&
    !props.home &&
    !props.active &&
    `
      margin-left: 0;
      margin-right: 25px;

      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        margin: 0;
      }
    `}

  ${Media.Below.desktop`
    padding: 10px 10px 10px 20px;
  `}
`;

export const CardCtn = styled.div<SlaProps>`
  flex: 0 0 68%;
  margin: 25px 0;

  ${Media.Below.desktop`
    margin: 20px 0;
  `}

  ${(props): SimpleInterpolation =>
    css &&
    !props.home &&
    `
      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        margin-bottom: 0;
      }
    `}
`;

interface DropdownProps {
  active?: boolean;
}

export const DropdownJobDetailCtn = styled.div<DropdownProps>`
  display: none;
  max-height: 0px;
  overflow-y: scroll;
  transition: all 0.5s ease-in-out;

  ${(props): SimpleInterpolation =>
    css &&
    props.active &&
    `
      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        max-height: 840px;
        padding-top: 30px;
        padding-bottom: 30px;
      }
    `}

  ${Media.Below.desktopLarge`
    display: flex;
    background-color: white;
    padding-right: 30px;
    padding-left: 30px;
  `}
`;

export const JobTitle = styled.div`
  flex: 0 1 60%;
  font-size: 20px;
  font-weight: bold;
  line-height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 45px;
  margin-bottom: 12px;

  ${Media.Below.desktop`
    font-size: 16px;
    line-height: 16px;
    height: 31px;
  `}
`;

export const TopCtn = styled.div`
  display: flex;
  justify-content: space-between;
`;
